function initCartRecommendationsArrows(root = document) {
  root.querySelectorAll('.cart-items--recommendations-container').forEach((container) => {
    const recommendations = container.querySelector('.cart-items--recommendations-grid');
    const previousButton = container.querySelector('.cart-items--recommendations--pagination-left');
    const nextButton = container.querySelector('.cart-items--recommendations--pagination-right');
    const item = recommendations?.querySelector('.cart-items--recommendations-list-item');

    if (!recommendations || !item || recommendations.dataset.arrowsInitialized === 'true') return;

    recommendations.dataset.arrowsInitialized = 'true';
    const styles = window.getComputedStyle(recommendations);
    const gap = parseFloat(styles.columnGap || styles.gap || 20);
    const scrollAmount = item.getBoundingClientRect().width + gap;

    const updateButtons = () => {
      const maximumScroll = recommendations.scrollWidth - recommendations.clientWidth;
      const tolerance = 2;

      previousButton?.classList.toggle('disabled', recommendations.scrollLeft <= tolerance);
      nextButton?.classList.toggle('disabled', recommendations.scrollLeft >= maximumScroll - tolerance);
    };

    previousButton?.addEventListener('click', () => {
      recommendations.scrollBy({ top: 0, left: -scrollAmount, behavior: 'smooth' });
    });

    nextButton?.addEventListener('click', () => {
      recommendations.scrollBy({ top: 0, left: scrollAmount, behavior: 'smooth' });
    });

    recommendations.addEventListener('scroll', updateButtons);
    updateButtons();
  });
}

class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loading === 'true') return;

    const cartDrawer = this.closest('cart-drawer');
    const productId = this.dataset.productId || cartDrawer?.productId;

    if (!productId || !this.dataset.url) {
      this.remove();
      return;
    }

    this.dataset.loading = 'true';
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('product_id', productId);

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('.cart-items--recommendations-container');

        if (!recommendations) {
          this.remove();
          return;
        }

        this.replaceWith(recommendations);
        initCartRecommendationsArrows(recommendations.parentElement || document);
      })
      .catch((error) => {
        console.error(error);
        this.remove();
      });
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}

document.addEventListener('DOMContentLoaded', () => {
  initCartRecommendationsArrows();
});

document.addEventListener('change', (event) => {
  const variant = event.target.closest('.cart-recommendation-variant');
  if (!variant) return;

  const recommendation = variant.closest('.cart-items--recommendations-list-item');
  const price = recommendation?.querySelector('.cart-recommendation-price');
  const selectedOption = variant.selectedOptions?.[0] || variant;
  if (price && selectedOption.dataset.price) price.textContent = selectedOption.dataset.price;
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('.cart-recommendation-add');
  if (!button) return;

  const form = button.closest('.cart-recommendation-form');
  const spinner = button?.querySelector('.loading__spinner');
  const errorMessage = form.querySelector('.cart-recommendation-error');
  const cartDrawer = form.closest('cart-drawer');
  const variantId = form.querySelector('select[name="id"], input[type="hidden"][name="id"]')?.value;

  if (!cartDrawer || !variantId || button.getAttribute('aria-disabled') === 'true') return;

  const formData = new FormData();
  formData.append('id', variantId);

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  spinner?.classList.remove('hidden');
  if (errorMessage) errorMessage.hidden = true;

  formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
  formData.append('sections_url', window.location.pathname);
  cartDrawer.setActiveElement(button);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(routes.cart_add_url, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) throw new Error(response.description || response.message);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-recommendations',
        productVariantId: variantId,
        cartData: response,
      });
      cartDrawer.renderContents(response);
    })
    .catch((error) => {
      if (errorMessage) {
        errorMessage.textContent = error.message || window.cartStrings.error;
        errorMessage.hidden = false;
      }
    })
    .finally(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      spinner?.classList.add('hidden');
    });
});
